import gql from 'graphql-tag';

export default gql`
  mutation updateStudentLevelUserGroupMutation($courseCategoryId: MongoID!, $groupId: MongoID!) {
    updateStudentLevelUserGroupMutation(courseCategoryId: $courseCategoryId, groupId: $groupId) {
      status
    }
  }
`;
